import React from 'react';
import {Link} from 'react-router-dom';
import {Icon} from '../../uiToolkit/Icon/Icon';
import {tapyblAiHomeText} from '../TapyblAI/Home/tapyblAiHomeText';
import styles from './DesktopLearning.module.css';

const DesktopLearning = React.memo(() => (
  <div className={styles.container}>
    <div className={styles.scroll}>
      <div className={styles.section}>
        <h1 className={styles.heading}>{tapyblAiHomeText.selection}</h1>
        <div className={styles.options}>
          <Link to="../home/generate_microlesson" className={styles.card}>
            <Icon name="microlesson.svg" className={styles.cardIcon} />
            <h2 className={styles.cardTitle}>
              {tapyblAiHomeText.microlessons}
            </h2>
            <p className={styles.cardText}>
              {tapyblAiHomeText.microlesosnsDescription}
            </p>
          </Link>
          <Link to="../home/generate_video" className={styles.card}>
            <Icon name="video.svg" className={styles.cardIcon} />
            <h2 className={styles.cardTitle}>{tapyblAiHomeText.videos}</h2>
            <p className={styles.cardText}>
              {tapyblAiHomeText.aiVideosDescription}
            </p>
          </Link>
          <Link to="../courses/create" className={styles.card}>
            <Icon name="course.svg" className={styles.cardIcon} />
            <h2 className={styles.cardTitle}>{tapyblAiHomeText.courses}</h2>
            <p className={styles.cardText}>
              {tapyblAiHomeText.coursesDescription}
            </p>
          </Link>
          <Link to="../ai_assistant" className={styles.card}>
            <Icon name="ai-assistant.svg" className={styles.cardIcon} />
            <h2 className={styles.cardTitle}>
              {tapyblAiHomeText.aiAssistants}
            </h2>
            <p className={styles.cardText}>
              {tapyblAiHomeText.aiAssistantsDescription}
            </p>
          </Link>
        </div>
      </div>
    </div>
  </div>
));

export default DesktopLearning;
